const APP_ROOT_PATH = {
  REACT_APP_ONLINE_TEST_ROOT_PATH: '/app/online-test-v2',
  REACT_APP_COURSE_EXERCISE_ROOT_PATH: '/app/course-exercise',
  REACT_APP_COURSE_EXERCISE_V2_ROOT_PATH: '/app/course-exercise-v2',
  REACT_APP_LMS_ROOT_PATH: '/app/lms-v2',
  REACT_APP_ENTRANCE_TEST_ROOT_PATH: '/app/entrance-test-v2',
  REACT_APP_STUDENT_ENTRANCE_TEST_ROOT_PATH: '/app/entrance-test-student',
  REACT_APP_STUDENT_ENTRANCE_TEST_SAT_ROOT_PATH: '/app/entrance-test-sat-student',
  REACT_APP_STUDENT_ENTRANCE_TEST_TOEIC_ROOT_PATH: '/app/entrance-test-toeic-student',
  REACT_APP_STUDENT_ENTRANCE_TEST_JUNIOR_ROOT_PATH: '/app/entrance-test-junior-student',
  REACT_APP_FINAL_TEST_ROOT_PATH: '/app/mid-final-test',
  REACT_APP_FINAL_TEST_STUDENT_ROOT_PATH: '/app/final-test-student',
  REACT_APP_LMS_AI_MOCK_TEST_ROOT_PATH: '/app/lms-ai-mock-test',
  REACT_APP_LMS_MENTAL_MODEL_ROOT_PATH: '/app/lms-mental-model',
  REACT_APP_LMS_COURSE_MANAGEMENT_ROOT_PATH: '/app/lms-course-management',
  REACT_APP_LMS_GRAMMAR_ROOT_PATH: '/app/lms-grammar',
  REACT_APP_LMS_TOEIC_ROOT_PATH: '/app/lms-toeic',
  REACT_APP_LMS_STUDENT_ROOT_PATH: '',
  REACT_APP_LMS_STUDENT_ADMIN_ORIGIN: 'https://superlms.dolenglish.vn',
  REACT_APP_FINAL_TEST_ORIGIN: 'https://student.dolenglish.vn',
  REACT_APP_LMS_ADMIN_ORIGIN: 'https://student.dolenglish.vn',
  REACT_APP_ENTRANCE_TEST_JUNIOR_ADMIN_ORIGIN: 'https://junior-entrance.dolenglish.vn',
  REACT_APP_ENTRANCE_TEST_IELTS_ADMIN_ORIGIN: 'https://ielts-entrance.dolenglish.vn',
  REACT_APP_ENTRANCE_TEST_TOEIC_ADMIN_ORIGIN: 'https://toeic-entrance.dolenglish.vn',
  REACT_APP_ENTRANCE_TEST_SAT_ADMIN_ORIGIN: 'https://sat-entrance.dolenglish.vn',
  REACT_APP_LMS_COURSE_MANAGEMENT_ADMIN_ORIGIN: 'https://student.dolenglish.vn',
  REACT_APP_LMS_TEACHER_ROOT_PATH: 'https://teacher.dolenglish.vn',
  REACT_APP_LMS_TEACHER_FINAL_TEST_ROOT_PATH: 'https://teacher.dolenglish.vn/final-test',
  REACT_APP_STUDENT_FINAL_TEST_TOEIC_ROOT_PATH: '/app/final-test-toeic-student',
  REACT_APP_STUDENT_FINAL_TEST_SAT_ROOT_PATH: '/app/final-test-sat-student',
};

const REDIRECT_URL = {
  // Online test
  REACT_APP_ONLINE_TEST_AUTH_REDIRECT_URL:
    'https://student.dolenglish.vn/app/online-test-v2/callback',
  REACT_APP_ONLINE_TEST_AUTH_LOGOUT_REDIRECT_URL:
    'https://student.dolenglish.vn/app/online-test-v2/login',

  // LMS
  REACT_APP_LMS_AUTH_REDIRECT_URL: 'https://student.dolenglish.vn/app/lms-v2/callback',
  REACT_APP_LMS_AUTH_LOGOUT_REDIRECT_URL: 'https://student.dolenglish.vn/app/lms-v2/login',

  // LMS Student
  REACT_APP_LMS_STUDENT_AUTH_REDIRECT_URL: 'https://superlms.dolenglish.vn/callback',
  REACT_APP_LMS_STUDENT_AUTH_LOGOUT_REDIRECT_URL: 'https://superlms.dolenglish.vn/login',

  // Entrance test
  REACT_APP_ENTRANCE_TEST_AUTH_REDIRECT_URL:
    'https://student.dolenglish.vn/app/entrance-test-v2/callback',
  REACT_APP_ENTRANCE_TEST_AUTH_LOGOUT_REDIRECT_URL:
    'https://student.dolenglish.vn/app/entrance-test-v2/login',

  // Entrance test Student
  REACT_APP_ENTRANCE_TEST_STUDENT_AUTH_REDIRECT_URL:
    'https://student.dolenglish.vn/app/entrance-test-student/callback',
  REACT_APP_ENTRANCE_TEST_STUDENT_AUTH_LOGOUT_REDIRECT_URL:
    'https://student.dolenglish.vn/app/entrance-test-student/login',

  // Entrance test IELTS Student
  REACT_APP_ENTRANCE_TEST_IELTS_AUTH_REDIRECT_URL: 'https://ielts-entrance.dolenglish.vn/callback',
  REACT_APP_ENTRANCE_TEST_IELTS_AUTH_LOGOUT_REDIRECT_URL:
    'https://ielts-entrance.dolenglish.vn/login',

  // Entrance test SAT Student
  REACT_APP_ENTRANCE_TEST_SAT_STUDENT_AUTH_REDIRECT_URL:
    'https://sat-entrance.dolenglish.vn/callback',
  REACT_APP_ENTRANCE_TEST_SAT_STUDENT_AUTH_LOGOUT_REDIRECT_URL:
    'https://sat-entrance.dolenglish.vn/login',

  // Entrance test TOEIC Student
  REACT_APP_ENTRANCE_TEST_TOEIC_STUDENT_AUTH_REDIRECT_URL:
    'https://toeic-entrance.dolenglish.vn/callback',
  REACT_APP_ENTRANCE_TEST_TOEIC_STUDENT_AUTH_LOGOUT_REDIRECT_URL:
    'https://toeic-entrance.dolenglish.vn/login',

  // dolacademy.vn
  REACT_APP_AUTH_DOL_VN_REDIRECT_URL: 'https://dolacademy.vn',
  REACT_APP_AUTH_DOL_VN_IN_APP_BROWSER_REDIRECT_URL: 'https://dolacademy.vn/callback',
  REACT_APP_AUTH_DOL_VN_LOGOUT_REDIRECT_URL: 'https://dolacademy.vn',

  // grammar.dolenglish.vn
  REACT_APP_AUTH_GRAMMAR_REDIRECT_URL: 'https://grammar.dolenglish.vn',
  REACT_APP_AUTH_GRAMMAR_LOGOUT_REDIRECT_URL: 'https://grammar.dolenglish.vn',
  REACT_APP_AUTH_GRAMMAR_IN_APP_BROWSER_REDIRECT_URL: 'https://grammar.dolenglish.vn/callback',

  // Final test
  REACT_APP_FINAL_TEST_AUTH_REDIRECT_URL:
    'https://student.dolenglish.vn/app/mid-final-test/callback',
  REACT_APP_FINAL_TEST_AUTH_LOGOUT_REDIRECT_URL:
    'https://student.dolenglish.vn/app/mid-final-test/login',

  // Final test student
  REACT_APP_FINAL_TEST_STUDENT_AUTH_REDIRECT_URL:
    'https://student.dolenglish.vn/app/final-test-student/callback',
  REACT_APP_FINAL_TEST_STUDENT_AUTH_LOGOUT_REDIRECT_URL:
    'https://student.dolenglish.vn/app/final-test-student/login',

  // Exercise V2 Student
  REACT_APP_EXERCISE_V2_STUDENT_AUTH_REDIRECT_URL:
    'https://superlms.dolenglish.vn/app/course-exercise-v2/callback',
  REACT_APP_EXERCISE_V2_STUDENT_AUTH_LOGOUT_REDIRECT_URL:
    'https://superlms.dolenglish.vn/app/course-exercise-v2/login',

  // Lms AI mock test
  REACT_APP_LMS_AI_MOCK_TEST_AUTH_REDIRECT_URL:
    'https://student.dolenglish.vn/app/lms-ai-mock-test/callback',
  REACT_APP_LMS_AI_MOCK_TEST_AUTH_LOGOUT_REDIRECT_URL:
    'https://student.dolenglish.vn/app/lms-ai-mock-test/login',

  // Lms mental model
  REACT_APP_LMS_MENTAL_MODEL_AUTH_REDIRECT_URL:
    'https://student.dolenglish.vn/app/lms-mental-model/callback',
  REACT_APP_LMS_MENTAL_MODEL_AUTH_LOGOUT_REDIRECT_URL:
    'https://student.dolenglish.vn/app/lms-mental-model/login',

  // Lms course management
  REACT_APP_LMS_LMS_COURSE_MANAGEMENT_AUTH_REDIRECT_URL:
    'https://student.dolenglish.vn/app/lms-course-management/callback',
  REACT_APP_LMS_LMS_COURSE_MANAGEMENT_AUTH_LOGOUT_REDIRECT_URL:
    'https://student.dolenglish.vn/app/lms-course-management/login',

  // Lms teacher
  REACT_APP_LMS_TEACHER_AUTH_REDIRECT_URL: 'https://teacher.dolenglish.vn/callback',
  REACT_APP_LMS_TEACHER_AUTH_LOGOUT_REDIRECT_URL: 'https://teacher.dolenglish.vn',
  REACT_APP_LMS_TEACHER_AUTH_IN_APP_BROWSER_REDIRECT_URL: 'https://teacher.dolenglish.vn/callback',

  // Lms Toeic
  REACT_APP_LMS_TOEIC_AUTH_REDIRECT_URL: 'https://student.dolenglish.vn/app/lms-toeic/callback',
  REACT_APP_LMS_TOEIC_AUTH_LOGOUT_REDIRECT_URL: 'https://student.dolenglish.vn/app/lms-toeic/login',

  // Lms eccs
  REACT_APP_AUTH_ECCS_REDIRECT_URL: 'https://cs.dolenglish.vn',
  REACT_APP_LMS_ECCS_AUTH_REDIRECT_URL: 'https://cs.dolenglish.vn/callback',
  REACT_APP_LMS_ECCS_AUTH_LOGOUT_REDIRECT_URL: 'https://cs.dolenglish.vn/',
  REACT_APP_AUTH_LMS_ECCS_DOMAIN: 'cs.dolenglish.vn',
  REACT_APP_LMS_ECCS_AUTH_IN_APP_BROWSER_REDIRECT_URL: 'https://cs.dolenglish.vn/callback',

  // Marketing
  REACT_APP_AUTH_MARKETING_REDIRECT_URL: 'https://marketing.dolenglish.vn',
  REACT_APP_MARKETING_AUTH_REDIRECT_URL: 'https://marketing.dolenglish.vn/callback',
  REACT_APP_MARKETING_AUTH_LOGOUT_REDIRECT_URL: 'https://marketing.dolenglish.vn/',
  REACT_APP_AUTH_MARKETING_DOMAIN: 'marketing.dolenglish.vn',
  REACT_APP_MARKETING_AUTH_IN_APP_BROWSER_REDIRECT_URL: 'https://marketing.dolenglish.vn/callback',
};

const AUTH_INFO = {
  REACT_APP_AUTH_DOMAIN: 'student.dolenglish.vn',
  REACT_APP_AUTH_DOL_VN_DOMAIN: 'dolacademy.vn',
  REACT_APP_AUTH_GRAMMAR_DOMAIN: 'grammar.dolenglish.vn',
  REACT_APP_AUTH_LMS_STUDENT_DOMAIN: 'superlms.dolenglish.vn',
  REACT_APP_AUTH_IELTS_ENTRANCE_DOMAIN: 'ielts-entrance.dolenglish.vn',
  REACT_APP_AUTH_SAT_ENTRANCE_DOMAIN: 'sat-entrance.dolenglish.vn',
  REACT_APP_AUTH_TOEIC_ENTRANCE_DOMAIN: 'toeic-entrance.dolenglish.vn',
  REACT_APP_AUTH_CLIENT_ID: 'AIzaSyDg4YuyLVZQTzvNI13Lc57Jf-ZDvT4fpSw',
  REACT_APP_AUTH_REAL_TIME_DB_URL:
    'https://dolenglish-auth-default-rtdb.asia-southeast1.firebasedatabase.app',
  REACT_APP_AUTH_PROJECT_ID: 'dolenglish-auth',

  REACT_AUTH_LOCAL_STORAGE_KEY: 'dolonline.auth',
  REACT_AUTH_PHONE_VERIFIED_LOCAL_STORAGE_KEY: 'auth.phone.verified',
  REACT_AUTH_CURRENT_USER_INFO: 'auth.currentuser.info',
  REACT_AUTH_CURRENT_USER_ID_TOKEN: 'auth.currentuser.id_token',
  REACT_AUTH_CURRENT_USER_CUSTOM_CLAIM: 'auth.currentuser.custom_claim',
  REACT_APP_AUTH_TEACHER_DOMAIN: 'teacher.dolenglish.vn',
  REACT_APP_AUTH_LMS_TEACHER_DOMAIN: 'teacher.dolenglish.vn',
};

const API_HOSTNAME = {
  // Main api
  REACT_APP_ONLINE_TEST_API_HOSTNAME: 'https://apigateway.dolenglish.vn/online-test-v2/api',
  REACT_APP_ONLINE_TEST_CHINA_API_HOSTNAME:
    'https://apigateway.dolenglish.vn/online-test-v2-china/api',
  REACT_APP_ONLINE_TEST_GLOBAL_API_HOSTNAME:
    'https://apigateway.dolenglish.vn/online-test-v2-global/api',
  REACT_APP_UNIVERSITY_API_HOSTNAME: '',
  REACT_APP_PAGE_MANAGEMENT_API_HOSTNAME: 'https://apigateway.dolenglish.vn/page-management/api',
  REACT_APP_PAGE_MANAGEMENT_CHINA_API_HOSTNAME:
    'https://apigateway.dolenglish.vn/page-management-china/api',
  REACT_APP_PAGE_MANAGEMENT_GLOBAL_API_HOSTNAME:
    'https://apigateway.dolenglish.vn/page-management-global/api',
  REACT_APP_EXERCISE_API_HOST_NAME: 'https://apigateway.dolenglish.vn/exercise/api',
  REACT_APP_EXERCISE_V2_API_HOST_NAME: 'https://apigateway.dolenglish.vn/exercise-v2/api',
  REACT_APP_AI_MOCK_TEST_API_HOST_NAME: 'https://apigateway.dolenglish.vn/mock-test/api',
  REACT_APP_VOCAB_API_HOSTNAME: 'https://apigateway.dolenglish.vn/vocab-v2/api',
  REACT_APP_DICTATION_API_HOSTNAME: 'https://apigateway.dolenglish.vn/dictation/api',
  REACT_PUBLIC_SERVICE_API_HOSTNAME: 'https://apigateway.dol.vn/public',
  REACT_APP_ROADMAP_API_HOST_NAME: 'https://apigateway.dolenglish.vn/roadmap/api',
  REACT_APP_GRAMMAR_API_HOSTNAME: 'https://apigateway.dolenglish.vn/grammar/api',
  REACT_APP_K12_API_HOSTNAME: 'https://apigateway.dolenglish.vn/k12/api',
  REACT_APP_K10_API_HOSTNAME: 'https://apigateway.dolenglish.vn/k10/api',
  REACT_APP_K12_ALL_SUBJECTS_API_HOSTNAME: 'https://apigateway.dolenglish.vn/k12-all-subject/api',
  REACT_APP_JUNIOR_API_HOSTNAME: 'https://apigateway.dolenglish.vn/junior/api',
  REACT_APP_PUBLIC_K12_API_HOSTNAME: 'https://apigateway.dolenglish.vn/public/k12/api',
  REACT_APP_PUBLIC_K12_ALL_SUBJECTS_API_HOSTNAME:
    'https://apigateway.dolenglish.vn/public/k12-all-subject/api',
  REACT_APP_PUBLIC_K10_API_HOSTNAME: 'https://apigateway.dolenglish.vn/public/k10/api',
  REACT_APP_PUBLIC_JUNIOR_API_HOSTNAME: 'https://apigateway.dolenglish.vn/public/junior/api',
  REACT_APP_HSA_API_HOSTNAME: 'https://apigateway.dolenglish.vn/hsa/api',
  REACT_APP_PUBLIC_HSA_API_HOSTNAME: 'https://apigateway.dolenglish.vn/public/hsa/api',
  REACT_APP_DICTIONARY_EV_API_HOSTNAME: 'https://apigateway.dolenglish.vn/ev-dictionary/api',
  REACT_APP_PUBLIC_DICTIONARY_EV_API_HOSTNAME:
    'https://apigateway.dolenglish.vn/public/ev-dictionary/api',
  REACT_APP_TOEIC_API_HOSTNAME: 'https://apigateway.dolenglish.vn/toeic/api',
  REACT_APP_TOEIC_PUBLIC_API_HOSTNAME: 'https://apigateway.dolenglish.vn/public/toeic/api',
  REACT_APP_MEMORIES_API_HOST_NAME: 'https://apigateway.dolenglish.vn/memories/api',
  REACT_GO_USER_API_HOSTNAME: 'https://apigateway.dolenglish.vn/go-user/api',
  REACT_APP_MATERIAL_API_HOST_NAME: 'https://apigateway.dolenglish.vn/material/api',
  REACT_APP_DOCUMENT_HISTORY_API_HOSTNAME: 'https://apigateway.dolenglish.vn/document-history/api',
  REACT_APP_GOTENBERG_API_HOSTNAME: 'https://apigateway.dolenglish.vn/gotenberg',
  REACT_APP_EDITOR_UTILS_API_HOSTNAME: 'https://apigateway.dolenglish.vn/editor-utils',

  REACT_APP_ENGLISH_UTILS_API_HOSTNAME: 'https://apigateway.dolenglish.vn/english-utils-worker/api',
  REACT_APP_MENTAL_MODEL_API_HOST_NAME: 'https://apigateway.dolenglish.vn/mental-model/api',
  REACT_APP_SPEECH_TO_TEXT_API_HOST_NAME: 'https://apigateway.dolenglish.vn/speech-to-text/api',
  REACT_APP_SPEECH_ANALYZER_API_HOST_NAME: 'https://apigateway.dolenglish.vn/speech-analyzer/api',
  REACT_APP_SPEECH_ANALYZER_WS_HOST_NAME: 'wss://apigateway.dolenglish.vn/speech-analyzer',

  // public v2
  REACT_PUBLIC_PAGE_MANAGEMENT_SERVICE_API_HOSTNAME:
    'https://apigateway.dolenglish.vn/public/page-management/api',
  REACT_PUBLIC_SEARCH_TRANSFORM_SERVICE_API_HOSTNAME:
    'https://apigateway.dolenglish.vn/public/search-transform/api',
  REACT_PUBLIC_TTS_SERVICE_API_HOSTNAME: 'https://apigateway.dolenglish.vn/public/tts/api',
  REACT_PUBLIC_ONLINE_TEST_V2_SERVICE_API_HOSTNAME:
    'https://apigateway.dolenglish.vn/public/online-test-v2/api',
  REACT_PUBLIC_MEMBERSHIP_SERVICE_API_HOSTNAME:
    'https://apigateway.dolenglish.vn/public/membership/api',
  REACT_PUBLIC_K12_SERVICE_API_HOSTNAME: 'https://apigateway.dolenglish.vn/public/k12/api',
  REACT_PUBLIC_USER_SERVICE_API_HOSTNAME: 'https://apigateway.dolenglish.vn/public/user/api',
  REACT_PUBLIC_ENTRANCE_TEST_API_HOSTNAME:
    'https://apigateway.dolenglish.vn/public/entrance-test/api',
  REACT_PUBLIC_MID_FINAL_TEST_API_HOSTNAME:
    'https://apigateway.dolenglish.vn/public/mid-final-test/api',
  REACT_PUBLIC_SAT_ENTRANCE_FINAL_API_HOSTNAME:
    'https://apigateway.dolenglish.vn/public/sat-entrance-final/api',
  REACT_PUBLIC_SAT_API_HOSTNAME: 'https://apigateway.dolenglish.vn/public/sat-service/api',
  REACT_PUBLIC_COURSE_APP_SHEET_API_HOSTNAME:
    'https://apigateway.dolenglish.vn/public/course-app-sheet/api',
  REACT_PUBLIC_OFFLINE_COURSE_API_HOSTNAME:
    'https://apigateway.dolenglish.vn/public/offline-course-management/api',
  REACT_PUBLIC_SEO_REDIRECT_API_HOSTNAME:
    'https://apigateway.dolenglish.vn/public/seo-redirect/api',
  REACT_PUBLIC_GRAMMAR_API_HOSTNAME: 'https://apigateway.dolenglish.vn/public/grammar/api',
  REACT_PUBLIC_K12_API_HOSTNAME: 'https://apigateway.dolenglish.vn/public/k12/api',
  REACT_PUBLIC_TOEIC_API_HOSTNAME: 'https://apigateway.dolenglish.vn/public/toeic/api',

  // App api host name
  REACT_APP_LANDING_API_HOSTNAME: 'https://dolacademy.vn/api',
  REACT_APP_DOL_CORP_WEBSITE_API_HOST_NAME: 'https://www.dolenglish.vn/api',
  REACT_APP_GRAMMAR_LANDING_API_HOSTNAME: 'https://grammar.dolenglish.vn/api',

  // K12
  REACT_APP_K12_SERVICE_API_HOSTNAME: 'https://apigateway.dolenglish.vn/k12/api',
  REACT_APP_K12_RESOURCE_MNG_API_HOSTNAME: 'https://apigateway.dolenglish.vn/k12-resource-mgmt/api',

  // Syllabus
  REACT_APP_SYLLABUS_MANAGEMENT_API_HOSTNAME: 'https://apigateway.dolenglish.vn/syllabus',

  // Mid Final
  REACT_APP_MID_FINAL_TEST_API_HOSTNAME: 'https://apigateway.dolenglish.vn/mid-final-test/api',

  // SAT
  REACT_APP_SAT_TEST_API_HOSTNAME: 'https://apigateway.dolenglish.vn/sat/api',
  REACT_APP_SAT_TEST_GLOBAL_API_HOSTNAME: 'https://apigateway.dolenglish.vn/sat-global/api',
  REACT_APP_ENTRANCE_SAT_TEST_API_HOSTNAME: 'https://apigateway.dolenglish.vn/entrance-sat/api',
  REACT_PUBLIC_APP_ENTRANCE_SAT_TEST_API_HOSTNAME:
    'https://apigateway.dolenglish.vn/public/entrance-sat/api',

  // Course app sheet
  REACT_APP_COURSE_APP_SHEET_API_HOSTNAME: 'https://apigateway.dolenglish.vn/course-app-sheet/api',

  // Other service
  REACT_APP_SEARCH_ENGINE_API_HOSTNAME: 'https://apigateway.dolenglish.vn/search-transform',
  REACT_APP_USER_SERVICE_API_HOSTNAME: 'https://apigateway.dolenglish.vn/user',
  REACT_APP_KAFKA_REST_API_HOSTNAME: 'https://kafka-rest.dolenglish.vn',
  REACT_APP_ACTIVITY_API_HOSTNAME: 'https://apigateway.dolenglish.vn/activity/api',
  REACT_S3_SERVICE_API_HOSTNAME: 'https://apigateway.dolenglish.vn/s3-service-v2/api',
  REACT_VERIFY_APP_API_HOSTNAME: 'https://apigateway.dolenglish.vn/verify-token/api',
  REACT_APP_AUTHORIZATION_API_HOSTNAME: 'https://apigateway.dolenglish.vn/authorization/api',
  REACT_APP_CMS_API_HOSTNAME: 'https://apigateway.dolenglish.vn/cms',
  REACT_APP_CMS_DIRECTUS_API_HOSTNAME: 'https://apigateway.dolenglish.vn/directus',
  REACT_APP_MEMBERSHIP_DOMAIN_NAME: 'https://apigateway.dolenglish.vn/membership/api',
  REACT_APP_COGNITIVE_SERVICE_API_HOST_NAME: 'https://apigateway.dolenglish.vn/tts/api',
  REACT_APP_ASSIGNMENT_API_HOST_NAME: 'https://apigateway.dolenglish.vn/assignment/api',
  REACT_APP_COURSE_MANAGEMENT_API_HOSTNAME:
    'https://apigateway.dolenglish.vn/offline-course-management/api',
  REACT_APP_ENTRANCE_TEST_API_HOSTNAME: 'https://apigateway.dolenglish.vn/entrance-test/api',

  REACT_APP_MARKING_FORM_API_HOSTNAME: 'https://apigateway.dolenglish.vn/marking-form/api',
  REACT_APP_FINAL_TEST_API_HOSTNAME: 'https://apigateway.dolenglish.vn/mid-final-test/api',
  REACT_APP_SEARCH_SERVICE_API_HOSTNAME: 'https://apigateway.dolenglish.vn/search-transform/api',
  // M2M
  REACT_APP_M2M_ONLINE_TEST_API_HOSTNAME: 'http://online-test-v2-api-prod-dol-api/api',
  REACT_APP_M2M_PAGE_MANAGEMENT_API_HOSTNAME: 'http://page-management-api-prod-dol-api/api',
  REACT_APP_M2M_DOL_CORP_WEBSITE_API_HOST_NAME: 'http://corp-website-prod-dol-web/api',
  REACT_APP_M2M_ENTRANCE_TEST_API_HOSTNAME: 'http://entrance-test-api-prod-dol-api/api',
  REACT_APP_M2M_MID_FINAL_TEST_API_HOSTNAME: 'http://mid-final-test-api-prod-dol-api/api',
  REACT_APP_M2M_SEARCH_SERVICE_API_HOSTNAME: 'http://search-transform-prod-dol-api/api',
  REACT_APP_M2M_COURSE_APP_SHEET_API_HOSTNAME: 'http://course-app-sheet-api-prod-dol-api/api',
  REACT_APP_M2M_OFFLINE_COURSE_API_HOSTNAME:
    'http://offline-course-management-api-prod-dol-api/api',

  // QUIZ
  REACT_APP_QUIZ_TEST_API_HOSTNAME: 'https://apigateway.dolenglish.vn/quiz-test/api',

  // Other services
  REACT_TRACK_USER_LOCATION_HOST_NAME:
    'https://asia-southeast1-dolenglish-auth.cloudfunctions.net/user-location',
  REACT_GOOGLE_CLOUD_AUDIO_SERVICE: 'https://audio-service-2d746c6kia-as.a.run.app/api',
  REACT_APP_WORD_CHECKER_API_HOSTNAME: 'https://apigateway.dolenglish.vn/word-checker/api',
  REACT_APP_WRITING_ASSESSMENT_API_HOSTNAME:
    'https://apigateway.dolenglish.vn/writing-assessment/api',

  REACT_APP_SEO_REDIRECT_API_HOSTNAME: 'https://apigateway.dolenglish.vn/seo-redirect/api',
  REACT_APP_VIDEO_SERVICE_API_HOSTNAME: 'https://apigateway.dolenglish.vn/video/v1/api',

  REACT_PUBLIC_GO_USER_API_HOSTNAME: 'https://apigateway.dolenglish.vn/public/go-user/api',
  REACT_PUBLIC_ASSIGNMENT_API_HOSTNAME: 'https://apigateway.dolenglish.vn/public/assignment/api',

  REACT_PUBLIC_APP_AI_MOCK_TEST_API_HOST_NAME:
    'https://apigateway.dolenglish.vn/public/mock-test/api',
  REACT_PUBLIC_APP_DICTATION_API_HOSTNAME: 'https://apigateway.dolenglish.vn/public/dictation/api',
  REACT_PUBLIC_APP_EXERCISE_V2_API_HOST_NAME:
    'https://apigateway.dolenglish.vn/public/exercise-v2/api',
  REACT_PUBLIC_APP_VOCAB_API_HOSTNAME: 'https://apigateway.dolenglish.vn/public/vocab-v2/api',
  REACT_PUBLIC_APP_MATERIAL_API_HOST_NAME: 'https://apigateway.dolenglish.vn/public/material/api',
};

const EXTERNAL = {
  REACT_APP_SUBMIT_LEAD_API:
    'https://j1qi7rfda2.execute-api.ap-southeast-1.amazonaws.com/student-registration',
  REACT_APP_TEXT_TO_SPEECH_API: 'https://wkftq343jbobj.vcdn.cloud/prod/text-to-speech',

  // CDN
  CDN_GET_PRIVATE_RESOURCE: 'https://media.dolenglish.vn',
  CDN_GET_PUBLIC_RESOURCE: 'https://cbq1uz9dtwobj.vcdn.cloud',
  CDN_GET_PREVIEW_AUDIO: 'https://uonaacwmwvobj.vcdn.cloud', // VNG cnd for view de
  FPT_CDN_GET_RESOURCE: 'https://s3-sgn10.fptcloud.com',

  // AWS
  AWS_APP_SYNC_HOST_NAME:
    'https://uvj4scxxobanbii5qb6p6nyq2q.appsync-api.ap-southeast-1.amazonaws.com/graphql',
  AWS_APP_SYNC_API_KEY: 'da2-woup2rztwbdnlfgqjtvjii5azm',

  // Facebook
  FACEBOOK_APP_ID: '722752771433071',

  // Customer IO
  REACT_APP_CUSTOMER_IO_SITE_ID: '3456380a6296996b0db3',

  // Hubspot DOL
  HUBSPOT_API_KEY: 'd5df27e5-a4e6-402f-bade-cb81792773c3',
  HUBSPOT_PORTAL_ID: '7195447',
  HUBSPOT_FORM_ID: 'cd1802bb-da52-445e-aba8-867a33d84bc4',

  // Hubspot UEF
  HUBSPOT_UEF_PORTAL_ID: '47430100',
  HUBSPOT_AVATAR_TEMPLATE_URL:
    'https://7195447.fs1.hubspotusercontent-na1.net/hub/7195447/hubfs/form-uploads/a24fcc4c-042b-4407-bef9-afc585361743',

  DIRECTUS_API_HOST_NAME: 'https://directus.dolenglish.vn',

  // Junior sheet
  REACT_APP_JUNIOR_SHEET:
    'https://docs.google.com/spreadsheets/d/1prd_O-v7QKh_iS2LyJeGyIaK8Tbj0iAe-p_0fKa3Buo/edit?gid=0#gid=0',
};

const SEO_REDIRECT = {
  SEO_REDIRECT_DOL_ENGLISH: 'https://www.dolenglish.vn',
  SEO_REDIRECT_TU_HOC_IELTS: 'https://dolacademy.vn',
  SEO_REDIRECT_TU_DIEN: 'https://tudien.dolenglish.vn',
  SEO_REDIRECT_GRAMMAR: 'https://grammar.dolenglish.vn',
};

export const environment = {
  ...APP_ROOT_PATH,
  ...REDIRECT_URL,
  ...AUTH_INFO,
  ...API_HOSTNAME,
  ...EXTERNAL,
  ...SEO_REDIRECT,
  production: true,
  LANDING_GLOBAL_CACHE_TTL: 10, // 10s cache
  REACT_APP_ENV: 'PROD',
  NEXT_PUBLIC_SENTRY_ENV: 'PRODUCTION',
  INTERNAL_PATH: 'internal',

  REACT_USER_SEARCH_LOCAL_STORAGE_KEY: 'dolonline.search',
  SEO_PREFIX: 'https://dolacademy.vn/',
  REACT_APP_DOL_CORP_WEBSITE_HOST_NAME: 'https://www.dolenglish.vn',
  REACT_APP_DOL_DICTIONARY_WEBSITE_HOST_NAME: 'https://tudien.dolenglish.vn',
  REACT_APP_DOL_GRAMMAR_WEBSITE_HOST_NAME: 'https://grammar.dolenglish.vn',
  REACT_APP_DOL_TEACHER_WEBSITE_HOST_NAME: 'https://teacher.dolenglish.vn',
  REACT_APP_DOL_SUPER_LMS_HOST_NAME: 'https://superlms.dolenglish.vn',
  REACT_APP_DOL_STUDENT_HOST_NAME: 'https://student.dolenglish.vn',

  GRAPH_CMS_CDN: 'https://asset.dolenglish.vn',
  REACT_APP_REFERRAL_DOMAIN_NAME: 'https://invite.dol.vn',
  REACT_APP_ENGLISH_GROUP_LINK: '',
  GIFT_CODE_ROUTER: 'https://www.google.com/',
  HUBSPOT_HOST_NAME: 'https://app.hubspot.com',
  LANDING_GRAMMAR_FULL_URL: 'https://grammar.dolenglish.vn',
};
